import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black border-t border-gray-800/50">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <div className="w-7 h-7 bg-white rounded-lg flex items-center justify-center mr-2">
                <svg className="w-4 h-4 text-black" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <span className="text-lg font-bold text-white">PropAlgos</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed">
              GPU-powered quantitative trading research. Build, backtest, and analyze
              strategies with institutional-grade infrastructure.
            </p>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/rules" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Competition Rules
                </Link>
              </li>
              <li>
                <a href="mailto:legal@propalgos.ai" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Contact: legal@propalgos.ai
                </a>
              </li>
            </ul>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/features" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/docs" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  About
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* DMCA Notice */}
        <div className="border-t border-gray-800/50 pt-6 mb-6">
          <p className="text-gray-600 text-xs leading-relaxed">
            If you believe material on Propalgos infringes your copyright, notify our
            Designated Agent at legal@propalgos.ai with: (1) Identification of the work;
            (2) URL of the infringing material; (3) Contact info; (4) Statement of good
            faith belief.
          </p>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-gray-600 text-xs">
            &copy; 2026 Propalgos.ai. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
